// Dedicated alphanumeric access key for the evacuation-training common provider.
const HINAN_KUNREN_COMMON_ACCESS_KEY = "a7Kp3Xn9Qw2Lm6Rt";
const HINAN_KUNREN_SEASON_ID = "cmt8v3v940001a4zc1b2v7nvx";

export {
  HINAN_KUNREN_COMMON_ACCESS_KEY,
  HINAN_KUNREN_SEASON_ID,
};
